<template>
  <WidgetPanel>
    <template #header>
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Aktionen
      </h3>
    </template>
    <template #default>
      <div class="divide-y divide-gray-200">
        <!-- Application -->
        <PracticeMenuItem v-if="applied" @click="unapply">
          <template #title>
            Dauerhaft in Anwendung
          </template>
          <template #icon>
            <CheckCircleIcon class="h-5 w-5 text-gray-800" aria-hidden="true" />
          </template>
        </PracticeMenuItem>
        <PracticeMenuItem v-else="applied" @click="apply">
          <template #title>
            Dauerhaft in Anwendung
          </template>
          <template #icon>
            <PlusCircleIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </template>
        </PracticeMenuItem>
        <!-- Bookmark -->
        <PracticeMenuItem v-if="bookmarked" @click="unbookmark">
          <template #title>
            Für später merken
          </template>
          <template #icon>
            <CheckCircleIcon class="h-5 w-5 text-gray-800" aria-hidden="true" />
          </template>
        </PracticeMenuItem>
        <PracticeMenuItem v-else="bookmarked" @click="bookmark">
          <template #title>
            Für später merken
          </template>
          <template #icon>
            <PlusCircleIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </template>
        </PracticeMenuItem>
        <!-- Rejection -->
        <PracticeMenuItem v-if="rejected" @click="unreject">
          <template #title>
            Nicht mehr empfehlen
          </template>
          <template #icon>
            <CheckCircleIcon class="h-5 w-5 text-gray-800" aria-hidden="true" />
          </template>
        </PracticeMenuItem>
        <PracticeMenuItem v-else="rejected" @click="reject">
          <template #title>
            Nicht mehr empfehlen
          </template>
          <template #icon>
            <PlusCircleIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </template>
        </PracticeMenuItem>
        <!-- Experiment -->
        <PracticeMenuItem @click="experiment">
          <template #title>
            Experiment starten
          </template>
          <template #icon>
            <ChevronRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </template>
        </PracticeMenuItem>
        <!-- Proposal -->
        <PracticeMenuItem @click="proposal">
          <template #title>
            Best Practice einreichen
          </template>
          <template #icon>
            <ChevronRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </template>
        </PracticeMenuItem>
        <!-- Feedback -->
        <PracticeMenuItem @click="feedback">
          <template #title>
            Feedback geben
          </template>
          <template #icon>
            <ChevronRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </template>
        </PracticeMenuItem>
      </div>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore} from 'vuex';
import client from '@/client/index';

const props = defineProps({practice: Object});
const model = ref(props.practice);
const router = useRouter();
const store = useStore();

const context = computed(() => store.getters['context/context']);

const applied = ref(props.practice.applied ?? false);
const rejected = ref(props.practice.rejected ?? false);
const bookmarked = ref(props.practice.bookmarked ?? false);

const bookmark = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/bookmarks';
  const params = {practice_id: model.value.id};

  client.post(target, params)
  .then(result => bookmarked.value = true)
  .catch(error => bookmarked.value = false);
};

const unbookmark = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/bookmarks';
  const params = {practice_id: model.value.id};

  client.delete(target, {data: params})
  .then(result => bookmarked.value = false)
  .catch(error => bookmarked.value = true);
};

const reject = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/rejections';
  const params = {practice_id: model.value.id};

  client.post(target, params)
  .then(result => rejected.value = true)
  .catch(error => rejected.value = false);
};

const unreject = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/rejections';
  const params = {practice_id: model.value.id};

  client.delete(target, {data: params})
  .then(result => rejected.value = false)
  .catch(error => rejected.value = true);
};


const apply = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/applications';
  const params = {practice_id: model.value.id};

  client.post(target, params)
  .then(result => applied.value = true)
  .catch(error => applied.value = false);
};

const unapply = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/applications';
  const params = {practice_id: model.value.id};

  client.delete(target, {data: params})
  .then(result => applied.value = false)
  .catch(error => applied.value = true);
};

const experiment = () =>
{
  const name = {name: 'experiments.create'};
  const query = {query: {practice_id: model.value.id}};
  router.push({...name, ...query});
};

const feedback = () => router.push({name: 'feedback'});
const proposal = () => router.push({name: 'feedback'});
</script>
